import styled from 'styled-components'
import { customTheme } from '../../styles/theme'

export const Wrapper = styled.div`
  height: 62px;

  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;

  display: flex;
  align-items: center;
  justify-content: center;

  background: #232323;

  @media (max-width: ${customTheme.breakpoints[1]}) {
    display: none;
  }
`

export const WrapperMobile = styled.div`
  height: 25px;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 999;
  display: none;
  align-items: center;
  justify-content: center;

  @media (max-width: ${customTheme.breakpoints[1]}) {
    display: flex;
  }
`

export const Container = styled.div`
  height: 100%;
  width: 100%;
  max-width: 95vw;
  padding: 10px 50px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: ${customTheme.breakpoints[1]}) {
    padding: 10px 0px;
    justify-content: space-around;
  }
`

export const Details = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  height: 100%;

  .logo-izap {
    height: 100%;
  }
`

export const Logo = styled.p`
  margin: 0px;
  
  font-weight: bold;
  font-size: 14px;
  line-height: 21px;
  color: ${customTheme.colors.white};

  & > span {
    font-weight: 500;
    font-size: 12px;
    line-height: 18px;
  }
`

export const Copyright = styled.p`
  margin: 0px;
  margin-left: 55px;

  display: flex;
  align-items: center;
  
  color: ${customTheme.colors.white};
  font-size: 16px;
  line-height: 44px;
  letter-spacing: -0.44px;
`

export const Menu = styled.div`
  display: flex;
  align-items: center;
  align-self: center;
  
  @media (max-width: ${customTheme.breakpoints[1]}) {
    place-content: center;
    flex-direction: row;
    flex-wrap: wrap;
  }
`

export const MenuItem = styled.a<any>`
  font-size: 16px;
  line-height: 24px;
  color: ${(props) => props.color || customTheme.colors.white};
  cursor: pointer;
  text-decoration: underline;
  
  & + & {
    margin-left: 25px;
  }

  &:hover {
    text-decoration: underline;
  }

  @media (max-width: ${customTheme.breakpoints[1]}) {
    font-size: 10px;

    & + & {
      margin-left: 5px;
    }
  }
`
export const Blank = styled.div`
  flex: 1;
`
export const WppLink = styled.div`
  flex: 1;
`
